import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
  CommunityWithVerifications,
  CreatePropertyVerificationBody,
  CreateSectionPropertiesVerificationBody,
  NoInfoBody,
  ProgramVerification,
  ProgramVerificationPublicStatus,
} from '@trp/community/program-verification/interfaces';

@Injectable({
  providedIn: 'root',
})
export class ProgramVerificationApiClient {
  httpClient = inject(HttpClient);

  getPublicStatus(nationalDbId: string) {
    return this.httpClient.get<ProgramVerificationPublicStatus>(
      '/program-verification/public-status/' + encodeURIComponent(nationalDbId)
    );
  }

  reportNoInfo(body: NoInfoBody) {
    return this.httpClient.post('/program-verification/reportNoInfo', body);
  }

  getVerificationsGroupByCommunity() {
    return this.httpClient.get<CommunityWithVerifications[]>(
      '/program-verification/byCommunity'
    );
  }

  notifyExpiredVerifications() {
    return this.httpClient.post<void>(
      '/program-verification/notify-expired',
      {}
    );
  }

  getAllVerificationsOfCommunity(communityId: string) {
    return this.httpClient.get<ProgramVerification[]>(
      '/program-verification?communityId=' + encodeURIComponent(communityId)
    );
  }

  create(body: CreatePropertyVerificationBody) {
    return this.httpClient.post<ProgramVerification>(
      '/program-verification',
      body
    );
  }

  createSectionVerifications(body: CreateSectionPropertiesVerificationBody) {
    return this.httpClient.post<ProgramVerification>(
      '/program-verification/section',
      body
    );
  }
}
